import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as taxbillApi from '../../lib/api/taxbill';

const [VIEW_TAXBILL, VIEW_TAXBILL_SUCCESS, VIEW_TAXBILL_FAILURE] =
  createRequestActionTypes('taxbill/VIEW_TAXBILL');
export const viewTaxbill = createAction(VIEW_TAXBILL, (id) => id);
const viewTaxbillSaga = createRequestSaga(VIEW_TAXBILL, taxbillApi.getTaxbill);

const UNLOAD_TAXBILL = 'taxbill/UNLOAD_TAXBILL';
export const unloadTaxbill = createAction(UNLOAD_TAXBILL);

const SET_TAXBILL = 'taxbill/SET_TAXBILL';
export const setTaxbill = createAction(SET_TAXBILL, (taxbill) => taxbill);

export function* taxbillSaga() {
  yield takeLatest(VIEW_TAXBILL, viewTaxbillSaga);
}

const initialState = {
  taxbill: null,
  roInfo: null,

  error: null,
};

const taxbill = handleActions(
  {
    [VIEW_TAXBILL_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      taxbill: data.info?.invInfo,
      roInfo: data.info?.roInfo,
    }),
    [VIEW_TAXBILL_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [SET_TAXBILL]: (state, { payload: taxbill }) => ({
      ...state,
      taxbill: taxbill,
    }),
    [UNLOAD_TAXBILL]: () => initialState,
  },
  initialState,
);

export default taxbill;
